import SideBarContent from "./SideBarContent";

/**
 * Fixed sidebar for desktop (>= lg). Hidden on mobile — the mobile nav is
 * provided by <MobileTopBar /> via an antd Drawer.
 */
function SideBar() {
    return (
        <aside className="hidden lg:flex flex-col min-w-[220px] w-56 bg-surface shadow-md h-full">
            <SideBarContent />
        </aside>
    );
}

export default SideBar;
